import styled from "@emotion/styled";

const MoratoriumMessageBox = styled.div`
  background-color: #fff3cd;
  border: 2px solid ${(props) => props.theme.color.state.orange};
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
  color: ${(props) => props.theme.color.grayscale[900]};
  white-space: pre-line;
  line-height: 1.5;

  strong {
    font-weight: 600;
  }
`;

export function MoratoriumMessage() {
  return (
    <MoratoriumMessageBox>
      Dear Producers,
      {"\n\n"}
      Effective immediately,{" "}
      <strong>
        American European Insurance Group is placing a temporary moratorium on
        binding coverage for all new property business due to the winter storm
        impacting the Northeast.
      </strong>
      {"\n\n"}
      This moratorium applies to <strong>new property business only</strong> and
      is expected to remain in place{" "}
      <strong>through at least the end of this week</strong>. We will provide an
      update as soon as we are able to lift the restriction or extend it, if
      necessary.
      {"\n\n"}
      For policies which have lapsed or been subject to a mid-term cancellation,
      we will require a <strong>currently dated loss warranty letter</strong> in
      order to reinstate coverage, and{" "}
      <strong>
        no accounts will be reinstated with any retroactive dates.
      </strong>
      {"\n\n"}
      This moratorium <strong>does not apply</strong> to our{" "}
      <strong>SKP – Artisan Contractor</strong> coverage.
      {"\n\n"}
      Thank you for your understanding and cooperation.
      {"\n\n"}
      Regards,
      {"\n"}
      The AE Underwriting Team
    </MoratoriumMessageBox>
  );
}
